import { css, cx } from "@linaria/core"

import { getPrStatusClassName } from "@/components/GitHubIntegration/PrStatusStyles.tsx"

import type { HTMLAttributes } from "react"


type PrStatusProps = HTMLAttributes<HTMLDivElement> & {
  kind: string
}

export const PrStatus = ({ className, ...props }: PrStatusProps) => {
  return (
    <span className={cx(styles.PrStatus, getPrStatusClassName(props.kind), className)}>{props.children}</span>
  )
}

const styles = {
  PrStatus: css`
    font-size: 9px;
    line-height: 14px;
    text-align: center;
    font-weight: 500;

    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 4px;

    padding: 2px 6px;

    border-radius: var(--border-radius-8);
  `,
}
